import { render, staticRenderFns } from "./DispositivoTable.vue?vue&type=template&id=f669a252&"
import script from "./DispositivoTable.vue?vue&type=script&lang=js&"
export * from "./DispositivoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports